import React, { useMemo } from 'react';
import cn from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import {
  getConflictingReasons,
  getConfirmationModalMessage,
  getConfirmationModalButtonText
} from '../../methods';
import { ReactComponent as WarningIcon } from 'assets/img/icons/warning.svg';
import { useRecommendationConfig } from '../../hooks';

export default function ConfirmationModal() {
  const {
    mode,
    data,
    initialData,
    isProcessing,
    showConfirmationModal,
    onConfirm,
    updateData,
    onCloseConfirmationModal
  } = useRecommendationConfig();

  const reasons = _get(data, 'attachedReasons', []);

  const conflictingReasons = useMemo(() => {
    return getConflictingReasons(data, initialData);
    // eslint-disable-next-line
  }, [reasons]);

  const onRemoveReason = reasonId => {
    if (!reasonId) return;
    const newReasons = [...reasons];
    const reasonsIndex = newReasons.findIndex(({ id }) => {
      return id === reasonId;
    });
    newReasons.splice(reasonsIndex, 1);
    updateData({ attachedReasons: newReasons });
  };

  const renderItems = conflictingReasons.map(
    ({ id, identifier, product_recommendation }) => {
      const title = _get(product_recommendation, 'recommendation_title', '');
      return (
        <UiKit.Grid
          key={id}
          gap="14"
          className="my-1 py-1"
          templateColumns="2fr 3fr"
        >
          <div>{identifier}</div>
          <UiKit.Grid gap="14" templateColumns="1fr auto">
            <div>{title}</div>
            <div
              onClick={() => onRemoveReason(id)}
              className={styles.removeBtn}
            >
              Remove
            </div>
          </UiKit.Grid>
        </UiKit.Grid>
      );
    }
  );

  const hasReasons = !_isEmpty(conflictingReasons);
  const message = getConfirmationModalMessage(hasReasons, mode);
  const buttonType = hasReasons ? 'destructive' : 'primary';
  const buttonText = getConfirmationModalButtonText(hasReasons, mode);

  return (
    <UiKit.Modal
      isOpen={showConfirmationModal}
      onClose={onCloseConfirmationModal}
      isProcessing={isProcessing}
      className={styles.container}
    >
      <UiKit.Modal.Header title="Notice!" />
      <UiKit.Modal.Body className={styles.body}>
        <UiKit.Grid gap="20" templateColumns="auto 1fr" className={styles.row}>
          <WarningIcon
            className={cn({
              [styles.negative]: hasReasons,
              [styles.positive]: !hasReasons
            })}
          />
          <p>{message}</p>
        </UiKit.Grid>
        <If test={hasReasons}>
          <p className="mb-2">List of conflicting request reasons</p>
          <UiKit.Grid gap="14" templateColumns="2fr 3fr" className="pb-1">
            <strong>Request Reason</strong>
            <strong>Recommendation Set</strong>
          </UiKit.Grid>
          {renderItems}
        </If>
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer
        onConfirm={() => onConfirm({ skipReasonCheck: true })}
        confirmBtnVariant={buttonType}
        confirmBtnText={buttonText}
      />
    </UiKit.Modal>
  );
}
